
import {Component, Prop, Ref, Vue} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import {TakipDurumu} from "@/enum/TakipDurumu";
import KapakHesabiInfo from "@/components/infos/KapakHesabiInfo.vue";

@Component({
  components: {
    KapakHesabiInfo: () => import('@/components/infos/KapakHesabiInfo.vue')
    , FormWrapper, Dates
  },
})


export default class HesapTarihiForm extends Vue {
  @Ref("kapakHesabiInfo") readonly kapakHesabiInfo!: KapakHesabiInfo;
  @Prop({default:new Date()})hesapTarihi!: Date;
  item: TakipEntity = new TakipEntity();
  oldHesapTarihi!: Date;

  print() {
    //yazdırda üst ve alttaki tarih/about:blank yazılarını kaldırır
    const header = document.querySelector("header");
    const footer = document.querySelector("footer");
    if (header) {
      header.style.display = "none";
    }
    if (footer) {
      footer.style.display = "none";
    }
    this.kapakHesabiInfo.print()
  }

  calculate() {
    if (this.hesapTarihi && this.oldHesapTarihi!=this.hesapTarihi) {
      if (this.item.takip_durumu===TakipDurumu.kapali){
        if (this.$helper.tarihStr(new Date())<this.$helper.tarihStr(this.hesapTarihi)){
          this.$http
              .post("/api/v1/takip/" + this.$route.params.id + "/faiz")
              .then((response) => {
                this.item = response.data;
                this.$emit('onSuccess');
              });
        }else{
          this.oldHesapTarihi=this.hesapTarihi;
          this.$http
              .post("/api/v1/takip/" + this.$route.params.id + "/faiz", {hesap_tarihi: this.hesapTarihi})
              .then((response) => {
                this.item = response.data;
                this.$emit('onSuccess');
              });
        }
      }else{
        this.oldHesapTarihi=this.hesapTarihi;
        this.$http
            .post("/api/v1/takip/" + this.$route.params.id + "/faiz", {hesap_tarihi: this.hesapTarihi})
            .then((response) => {
              this.item = response.data;
              this.$emit('onSuccess');
            });
      }


    }
  }

  onClose() {
    this.$emit("onClose");
  }
}
